// userUtils.js

export const normalizeEmail = (email: string): string =>
    email.toLowerCase().replace('@us.schott.com', '@schott.com');

export const emailsMatch = (email1: string, email2: string): boolean =>
    normalizeEmail(email1) === normalizeEmail(email2);

export const filterUsers = (users, inputValue) => {
    return users && users.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
};